/*
 * @Description: 
 * @Author: houcw
 * @Date: 2022-09-28 10:18:41
 * @LastEditTime: 2023-10-26 15:15:17
 * @LastEditors: houcw
 * @Reference: 
 */
import router from './router'
// import store from './store'
// import { asyncRoutes } from '@/utils/routerData'
import NProgress from 'nprogress' // progress bar
// import 'nprogress/nprogress.css' // progress bar style
// import {
// 	getItem,
// 	removeItem,
// } from '@/utils/auth' // get token from cookie

// import config from '@/utils/config'
NProgress.configure({
	showSpinner: false
}) // NProgress Configuration

const whiteList = ['/login','/register']
router.beforeEach(async (to, from, next) => {
	// start progress bar
	NProgress.start()
	const hasToken = sessionStorage.getItem('adminToken');//是否登录
	console.log(hasToken, 'hasToken')
	if (hasToken) {
		if (to.path === '/login') {
			let state = to.query.state;
			let token = to.query.token;
			if (state && token) {
				//安装
				if (state == config.stateByOperate) {
					sessionStorage.removeItem("adminToken");
					sessionStorage.removeItem("info");
					next({
						path: to.fullPath
					})
					return;
				}
			}
			next({
				path: '/'
			})
			return;
		}
		next()
	} else {
		if (whiteList.indexOf(to.path) >= 0) {
			next();
			return;
		}
		next(`/login`)
	}
})
router.afterEach(() => {
	NProgress.done()
})
